import React from 'react';
import serviceimg from '../../src/images/service/imgsm.png';

const Choose = ({ header }) => {
  return (
    <section className="flex flex-col gap-3 items-center justify-center h-[200px] w-full bg-banner overflow-x-hidden text-center">
      <div className="flex items-center gap-3 justify-center">
        <img
          src={serviceimg}
          alt="icon for why choose us"
          className="w-10 h-5" // Adjust size as needed
        />
        <h3 className="text-[#F0FFC5] font-semibold text-md">
          {header?.title || 'WHY CHOOSE US'}
        </h3>
      </div>
      <div className="md:mx-0 mx-3 text-center">
        <h2 className="text-[#FFFF] text-3xl font-bold">
          {header?.subtitle || 'An Automotive Solution Initiative by Industry Experts'}
        </h2>
      </div>
    </section>
  );
};

export default Choose;
